import { WarningOrangeIcon } from "components/ui/icons/Warning/WarningOrangeIcon"
import { GeneralFeedbackForResponse } from "../../../GeneralFeedbackForResponse/GeneralFeedbackForResponse"
import style from "./WarningMessage.module.scss"

const { warningMessage, wrapper, chatBottomBar } = style

type Props = { text: string; status: string }

export const WarningMessage = ({ text, status }: Props) => {
	return (
		<div className={warningMessage}>
			<div className={wrapper}>
				<span>
					<WarningOrangeIcon />
				</span>
				<p>{text}</p>
			</div>

			{/* Show feedback when the status is not success */}
			{status !== "success" ? (
				<div className={chatBottomBar}>
					<GeneralFeedbackForResponse />
				</div>
			) : null}
		</div>
	)
}
